import { Component, ElementRef, forwardRef, HostListener, ViewChild } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { AdminTableCell } from '../admin-table-cell';

@Component({
  selector: 'mpro-atable-actions-cell',
  templateUrl: './admin-table-actions-cell.component.html',
  styleUrls: ['./admin-table-actions-cell.component.scss'],
  providers: [{ provide: AdminTableCell, useExisting: forwardRef(() => AdminTableActionsCellComponent) }]
})
export class AdminTableActionsCellComponent extends AdminTableCell {
  @ViewChild('wrapper') public wrapper: ElementRef<HTMLElement>;
  @ViewChild(FaIconComponent, { read: ElementRef }) public icon: ElementRef<HTMLElement>;
  public faEllipsisH = faEllipsisH;
  public isOpen: boolean = false;
  public x: number;
  public y: number;

  @HostListener('window:resize')
  public onResize() {
    this.setPoints();
  }

  public toggle() {
    this.setPoints();
    this.isOpen = !this.isOpen;
  }

  public closeWhenClickedOutside(event: MouseEvent) {
    this.isOpen = false;
  }

  private setPoints(): void {
    this.x = this.wrapper.nativeElement.getBoundingClientRect().width / 2 + this.icon.nativeElement.getBoundingClientRect().width;
    this.y = this.wrapper.nativeElement.getBoundingClientRect().height / 2;
  }
}